import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useConfirmationModal } from 'shared/components/ConfirmationModal';
import { REPRESENTATIVES_QUERY_STRING } from 'shared/constants/REPRESENTATIVES_QUERY_STRING';
import { ROUTES } from 'shared/constants/ROUTES';
import { representativeService } from 'shared/services/representativesService';

const { deleteRepresentative, getRepresentativesProfile } = representativeService();

export const useEditProfileDelete = (
  profileId: string,

  errorCallback: (title: string, message: string) => void,
) => {
  const { data: repData } = getRepresentativesProfile();
  const profiles = repData?.data?.profiles || [];
  const isSoloRep =
    profiles &&
    profiles.length === 1 &&
    profiles[0].agency &&
    profiles[0].representation_type === 'agency_representation';

  const isSoloFreelance =
    profiles && profiles.length === 1 && (!profiles[0].agency || profiles[0].representation_type === 'non_represented');
  const { ConfirmationModal, handleOpen, isOpen } = useConfirmationModal({
    type: 'warning',
    title: 'Delete Representative',
    message: isSoloRep
      ? 'This is your only existing profile, deleting this will auto create a Freelance/Personal Profile.'
      : 'This will delete your representative. This action is irreversible. Are you sure you want to proceed?',
  });
  const history = useHistory();
  const queryClient = useQueryClient();
  const { mutate: deleteRepresentativeMutate, isLoading: isDeleting } = deleteRepresentative();

  const handleDeleteConfirmation = useCallback(() => {
    if (isSoloFreelance) {
      errorCallback(
        'Delete Representative',
        'You cannot remove this profile, if you wish to remove this you would need to delete your entire profile on casting.com in your account settings',
      );
    } else {
      handleOpen();
    }
  }, [isSoloFreelance, isSoloRep]);

  const handleDeleteRepresentative = useCallback(() => {
    deleteRepresentativeMutate(profileId, {
      onSuccess: async () => {
        await queryClient.invalidateQueries([REPRESENTATIVES_QUERY_STRING.representatives_multiple_profile], {
          refetchInactive: true,
        });
        history.push(ROUTES.TALENT.REPRESENTATIVES);
      },
      onError: () => {
        errorCallback('Something went wrong', 'Cannot delete your profile at the moment');
      },
    });
  }, [profileId]);

  return { isDeleting, handleDeleteRepresentative, ConfirmationModal, handleDeleteConfirmation, isOpen };
};
